import { render } from "./CommonSettingsStage.vue?vue&type=template&id=0986531a"
import script from "./CommonSettingsStage.vue?vue&type=script&lang=js"
export * from "./CommonSettingsStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__